<template>
  <section id="recentPosts" class="hero is-small">
    <div class="hero-body">
      <div class="container">
        <h1 class="has-text-centered" style="margin-bottom: 3em;">Posts tagged with "{{ category }}"</h1>
        <ul>
          <li v-for="(post, key) in posts" :key="key">

            <nuxt-link :to="'/posts/'+post.title_slug">
              <h2>
                {{ post.title }}
              </h2>

            </nuxt-link>
            <div class="postTags">
              <span class="posted">POSTED {{ post.datePublished | toDate }}</span>
              <nuxt-link v-for="(tag, keyy) in post.tags" :key="keyy" :to="'/category/'+tag" class="ml-1">#{{ tag }}&nbsp;&nbsp;</nuxt-link>
            </div>
            <div class="postContent" v-html="post.excerpt" />
            <nuxt-link :to="'/posts/'+post.title_slug">
              Read more
            </nuxt-link>
            <hr>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  async asyncData ({ app, params, error, payload }) {
    if (payload) {
      return { posts: payload, category: params.tag }
    } else {
      const { data } = await app.$axios.post(process.env.POSTS_URL,
        JSON.stringify({
          filter: { published: true, tags: { $has: params.tag } },
          sort: { _created: -1 },
          populate: 1
        }),
        {
          headers: { 'Content-Type': 'application/json' }
        })

      if (!data.entries[0]) {
        return error({ message: '404 Page not found', statusCode: 404 })
      }

      return { posts: data.entries, category: params.tag }
    }
  },
  head () {
    return {
      title: 'Blog',
      link: [
        {
          rel: 'canonical',
          href: 'https://paccurate.io/blog'
        }
      ]
    }
  }
}
</script>

<style scoped>
  span.posted{
    display: inline-block;
    margin-right: 1em;
  }
  #recentPosts h2{
    margin-bottom: 0em;
  }
  .postTags{
    margin-bottom: 1em;
  }
</style>
